import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, EffectFade } from 'swiper/modules'; // EffectCreative yerine EffectFade
import 'swiper/css';
import 'swiper/css/effect-fade'; // EffectFade için CSS
import 'swiper/css/autoplay';
import SlideText from './SlideText';

const Slider = () => {
  return (
    <div className="h-screen w-full relative bg-white">
      <div className="absolute z-[10] left-[10%] top-[10%]">
        {/* İsterseniz başlıklar veya butonlar ekleyebilirsiniz */}
      </div>

      <Swiper
        modules={[Autoplay, EffectFade]} // Autoplay ve EffectFade modüllerini dahil ettik
        autoplay={{ delay: 3000, disableOnInteraction: false }} // Autoplay ayarları (gecikme 3 saniye)
        effect="fade" // Fade animasyon efekti
        fadeEffect={{ crossFade: true }} // Yumuşak geçiş için crossFade
        className="h-full w-full"
      >
        <SwiperSlide className="h-full w-full">
          <img
            src={'/images/anasayfa/slider/1.jpg'}
            className="h-full w-full object-cover"
            alt="Slide 1"
          />
        </SwiperSlide>
        <SwiperSlide className="h-full w-full">
          <img
            src={'/images/anasayfa/slider/2.jpg'}
            className="h-full w-full object-cover"
            alt="Slide 2"
          />
        </SwiperSlide>
        {/* <SwiperSlide className="h-full w-full">
          <img
            src={'/images/anasayfa/slider/3.jpg'}
            className="h-full w-full object-cover"
            alt="Slide 2"
          />
        </SwiperSlide> */}
        <SwiperSlide className="h-full w-full">
          <img
            src={'/images/anasayfa/slider/4.jpg'}
            className="h-full w-full object-cover"
            alt="Slide 2"
          />
        </SwiperSlide>
        <SwiperSlide className="h-full w-full">
          <img
            src={'/images/anasayfa/slider/5.jpg'}
            className="h-full w-full object-cover"
            alt="Slide 2"
          />
        </SwiperSlide>
        <SwiperSlide className="h-full w-full">
          <img
            src={'/images/anasayfa/slider/6.jpg'}
            className="h-full w-full object-cover"
            alt="Slide 2"
          />
        </SwiperSlide>
        <SwiperSlide className="h-full w-full">
          <img
            src={'/images/anasayfa/slider/7.jpg'}
            className="h-full w-full object-cover"
            alt="Slide 2"
          />
        </SwiperSlide>
        {/* Diğer slider içeriklerini ekleyebilirsiniz */}
      </Swiper>

      {/* <SlideText /> */}
    </div>
  );
};

export default Slider;
